import {useProductDetails} from "../../store/productDetails";
import {useState} from "@wordpress/element";
import {VariationsSelector} from "./VariationsSelector";

const FooterSkeleton = () => (
    <div className="mb-20 animate-pulse">
        <div className="flex gap-8 mb-10 border-t-4 border-base-200 pt-4">
            <div className="h-4 w-16 bg-base-300 rounded"/>
            <div className="h-4 w-24 bg-base-300 rounded"/>
        </div>
        <div className="space-y-4">
            <div className="h-4 bg-base-300 rounded w-full"/>
            <div className="h-4 bg-base-300 rounded w-5/6"/>
            <div className="h-4 bg-base-300 rounded w-4/6"/>
            <div className="h-4 bg-base-300 rounded w-full"/>
            <div className="h-4 bg-base-300 rounded w-3/4"/>
        </div>
    </div>
);

export const ProductDetailsFooter = () => {
    const {
        product: d,
        data,
    } = useProductDetails();

    const [activeTab, setActiveTab] = useState('details');

    const tabs = [
        {id: 'details', label: 'Details'},
        {id: 'specifications', label: 'Specifications'}
    ];

    const wpDescription = window.epiProduct?.description;
    const description = wpDescription || d.longDescription;

    return (
        <div className="mb-20">
            <div className="flex gap-8 mb-10 border-t-4 border-base-200">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        className={`pt-4 text-sm font-bold uppercase tracking-widest transition-all border-t-4 -mt-1 ${
                            activeTab === tab.id
                                ? 'border-primary pt-text-blue'
                                : 'border-transparent text-base-content/40 hover:text-base-content/60'
                        }`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {activeTab === 'details' && (
                <div className="animate-in fade-in duration-500">
                    <div className="space-y-8">
                        {Array.isArray(d?.variations) && d.variations.length > 0 && (
                            <div className="mb-8 p-4 rounded-xl">
                                <h3 className="text-sm font-bold uppercase mb-4 text-base-content/60">Available
                                    Variations</h3>
                                <VariationsSelector
                                    variations={d.variations}
                                    currentSku={String(d.sku)}
                                />
                            </div>
                        )}
                        {description && (
                            <div
                                className="prose prose-sm max-w-full text-base-content/80 leading-relaxed"
                                dangerouslySetInnerHTML={{__html: description}}
                            />
                        )}

                        {!description && (
                            <div className="text-base-content/50 italic py-8">
                                No additional details available for this product.
                            </div>
                        )}
                    </div>
                </div>
            )}

            {activeTab === 'specifications' && (
                <div className="animate-in fade-in duration-500">
                    {data.details && data.details.length > 0 ? (
                        <div>
                            <div
                                className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4 bg-white p-8 rounded-2xl border border-base-200 shadow-sm">
                                {data.details.map((detail, index) => (
                                    <div key={index}
                                         className="flex justify-between py-3 border-b border-base-100 last:border-0">
                                        <span
                                            className="text-sm font-semibold text-base-content/60">{detail.name}</span>
                                        <span
                                            className="text-sm font-medium text-base-content text-right ml-4">{detail.value}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="text-base-content/50 italic py-8">
                            No technical specifications available for this product.
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};